module.exports = __webpack_public_path__ + "static/img/menu-bg.8053fd9d.png";